import React from "react";

import { Flex } from "@chakra-ui/react";
import { ProfileCard } from "@ovou-inc/ovou-ui";

import { useElementWidthLayout } from "hooks/useElementWidthLayout";

import type { IProfile } from "types/Profile";

import { buildProfileCardProps } from "./buildProfileCardProps";

const PREVIEW_PADDING = 16;

interface ILogoPreviewPanelProps {
  profile: IProfile;
  croppedLogo?: string;
}

const LogoPreviewPanel: React.FC<ILogoPreviewPanelProps> = ({
  profile,
  croppedLogo,
}) => {
  const { ref: containerRef, width: containerWidth } = useElementWidthLayout();

  const cardWidth = Math.max(0, containerWidth - PREVIEW_PADDING * 2);
  const hasMeasured = cardWidth > 0;

  const profileCardProps = buildProfileCardProps(profile, {
    width: cardWidth,
    logoOverride: croppedLogo,
  });

  return (
    <Flex
      ref={containerRef}
      w="100%"
      justify="center"
      px={`${PREVIEW_PADDING}px`}
    >
      {hasMeasured && <ProfileCard {...profileCardProps} />}
    </Flex>
  );
};

export default LogoPreviewPanel;
